import React, { useEffect, useState  } from "react";
import { useNavigate } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightFromBracket, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import { auth, logout, getData, updateCheckListWithInputs, updateDataByUserId } from "../../configs/firebase";
import { onAuthStateChanged } from "firebase/auth";

import { IMAGES } from "../../constants/index"

import './CheckListPage.css';

import { CHECKLSIT, CHECKLSIT_START, DAILY_READ} from "../../constants/checkList"
import NOTION from "../../constants/notion"
import { CAMPAIGN_DATE } from "../../constants/constants"

function CheckListPage(){
    let navigate = useNavigate();
    
    const [user, setUser] = useState(null);
    const [data,setData] = useState(null)
    const [opacity, setOpacity] = useState(0);
    const [dayIndex,setDayIndex] = useState(null)
    const [inputs, setInputs] = useState([]);
    const [validateCount, setValidateCount] = useState(null)
  
    
    // 🔹 로그인 상태 감지
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            if(currentUser) setUser(currentUser);
            else handlelogout()
        });
        return () => unsubscribe();
    }, []);

    // 🔹 첫 시작 시 페이드 인 적용
    useEffect(() => {
        if(user){
            getUserData()
        }
    }, [user]);

    useEffect(() => {
        if(dayIndex!=null&&data!=null){
            validateDate(data.lastestUpdateDate)
        }
    }, [dayIndex,data]);

    useEffect(() => {
        if(validateCount){
            setOpacity(0); // 🔥 페이드 아웃 시작
            setTimeout(async () => {
                if(validateCount===(dayIndex===0? CHECKLSIT_START.length:CHECKLSIT.length)){
                    handleNavigation('/rhema')
                } else {
        
                    // 🔹 현재 Firestore에서 가져온 data.rhema가 배열인지 확인
                    const existingRhema = Array.isArray(data?.rhema) ? data.rhema : [];
                    const rhema = {"rhema":"","address":""}
                    // 🔹 새로운 데이터 추가
                    const dataTemp = {
                        rhema: [...existingRhema, rhema] // 🔥 기존 데이터 유지 + 새로운 데이터 추가
                    };
            
                    // 🔹 상태 업데이트 & Firestore 업데이트  
                    await updateDataByUserId(user.uid, dataTemp);
                    handleNavigation('/myFaith')
                }
            }, 2000);
        }
    }, [validateCount]);


    
    const getUserData = async () => {
        const data = await getData(user.uid)
        setData(data[0])
        setDayIndex(Object.keys(data[0]?.checkList || {}).length);
        if(Object.keys(data[0]?.checkList || {}).length===8){
            if(!data[0].event.epilogue)handleNavigation('/epilogue')
            else handleNavigation('/myFaith')
        }
    }
    const confirm = async () => {
        const isConfirmed = window.confirm("제출하시겠습니까?");
        if (isConfirmed) {
            await updateCheckListWithInputs(user.uid, dayIndex, inputs);
            await validateCheck()
        }        
    }
    const validateCheck = async () => {
        let count = 0;
        inputs?.map((input,index)=>{
            if(input==true||input?.length>0) {
                count++;
            }
        })
        setValidateCount(count);
    }
    const handleChange = (index, value) => {
        const newInputs = [...inputs];
        newInputs[index] = value;
        setInputs(newInputs); // 🔥 특정 인덱스의 값만 변경
    };
    const handleNavigation = (address) => {
        navigate(address);
    }
    const handleBack = () => {
        setOpacity(0);
        setTimeout(() => {
            navigate('/byFaith');
        }, 2000);
    }
    const handlelogout = async() => {
        const isConfirmed = window.confirm("로그아웃 하시겠습니까?");
        if (isConfirmed) {
            try{
                const result = await logout()
                navigate('/login');
            } catch (e) {
                console.error("로그아웃에 실패했습니다.", e)
            }
        }
    }

    function validateDate(updatedDate) {
        if (!updatedDate) {
            setOpacity(1);
            return false;
        }
    
        // 🔹 1. 한국 시간(KST) 기준 오늘 날짜 가져오기
        const today = new Date().toLocaleDateString("ko-KR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        }).replace(/. /g, "-").replace(".", ""); // ✅ "2025-02-22" 형식으로 변환
    
        // 🔹 2. updatedDate에서 날짜 부분만 추출 (예: "2025. 02. 22." → "2025-02-22")
        const updatedDateString = updatedDate.split(" ")[0].replace(/. /g, "-").replace(".", "");
        // console.log(today,updatedDateString,CAMPAIGN_DATE[dayIndex],today == updatedDate,updatedDate == CAMPAIGN_DATE[dayIndex-1])

        // 🔹 3. 날짜 비교 후 결과 반환
        if (today == updatedDateString && updatedDateString == CAMPAIGN_DATE[dayIndex-1]) {
            // console.log("✅ 최신!");
            let url;

            if(Object.keys(data?.checkList || {}).length === Object.keys(data?.rhema || {}).length) url='/myFaith';
            else url = '/rhema'

            setOpacity(0);
            setTimeout(() => {
                handleNavigation(url)
            }, 2000);
            return true;
        } else {
            // if(dayIndex===4) {
            //     let url;
            //     // console.log(data, Object.keys(data?.checkList || {}).length,Object.keys(data?.rhema || {}).length)
            //     if(Object.keys(data?.checkList || {}).length === Object.keys(data?.rhema || {}).length) url='/myFaith';
            //     else url = '/rhema'
    
            //     setOpacity(0);
            //     setTimeout(() => {
            //         handleNavigation(url)
            //     }, 2000);
            //     return true;
            // }
            setTimeout(() => {
                setOpacity(1);
            }, 500); // 0.5초 후 페이드 인
        }
    }

    return (
        <div
            className="wrap"
            style={{
                backgroundImage: `url(${IMAGES.BACKGROUMND})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <div className="checkListWrap" style={{ opacity, transition: "opacity 1s ease-in-out" }}>
                <div className="contentsTitle">
                    <span className="iconButton" onClick={handleBack}>
                        <FontAwesomeIcon className="iconBtn" icon={faArrowLeft} style={{color:"#131835"}}/>
                    </span>
                    <span>{NOTION[dayIndex]?.name} 믿음 체크하기</span>
                    <span className="iconButton" onClick={handlelogout}>
                        <FontAwesomeIcon className="iconBtn" icon={faRightFromBracket} style={{color:"#131835"}}/>
                    </span>
                </div>
                <div className="contetns">
                    {dayIndex===0&&CHECKLSIT_START.map((checklist,index)=>{
                        return (
                            <div key={checklist.index}>
                                <div className="checkListRow">
                                    {checklist.type==="checkbox"&&
                                    <>
                                    <span className="checkListBox">
                                        <label className="custom-checkbox">
                                            <input type="checkbox" className="checkListCheck" onChange={(e) => handleChange(index, e.target.checked)}/>
                                            <span className="checkmark"></span>
                                        </label>
                                    </span>
                                    <pre className="checkListList">{checklist.checkList}</pre>
                                    </>
                                    }
                                </div>
                            </div>)
                    })}
                    {dayIndex!==0&&CHECKLSIT.map((checklist,index)=>{
                        return (
                            <div key={checklist.index}>
                            {index===0&&DAILY_READ[dayIndex]===""? "":<>
                                <div className="checkListRow">
                                    {checklist.type==="checkbox"&&
                                    <>
                                    <span className="checkListBox">
                                        <label className="custom-checkbox">
                                            <input type="checkbox" className="checkListCheck" onChange={(e) => handleChange(index, e.target.checked)}/>
                                            <span className="checkmark"></span>
                                        </label>
                                    </span>
                                    <pre className="checkListList">{index===0&&DAILY_READ[dayIndex]}{DAILY_READ[dayIndex]===""? "":checklist.checkList}</pre>
                                    
                                    </>
                                    }
                                    {checklist.type==="text"&&
                                    <>
                                    <span className="checkListList">{index===0&&DAILY_READ[dayIndex]} {checklist.checkList}</span>
                                    <textarea type="text" className="checkListTextInput" rows={5} maxLength={200} placeholder={checklist.description} onChange={(e) => handleChange(index, e.target.value)}></textarea>
                                    </>
                                    }
                                </div>
                                </>
                            }
                        </div>)
                    })}
                </div>    
                <div className="contentsButton">
                    <span onClick={confirm}>확인하기</span>
                </div>
            </div>
        </div>
    );
  }
  export default CheckListPage;